// URL.parse polyfill for browsers that don't support it
// URL.parse is an experimental API that may not be available in all browsers

// TypeScript declaration for URL.parse
declare global {
  interface URLConstructor {
    parse(url: string, base?: string | URL): URL | null;
  }
}

// Polyfill implementation
if (!URL.parse) {
  URL.parse = function(url: string, base?: string | URL): URL | null {
    try {
      return new URL(url, base);
    } catch (error) {
      // If URL construction fails, return null (same behavior as native URL.parse)
      return null;
    }
  };
}

export {};